<template>
  <div style="padding:15px;" class="containerTable">
    <vxe-toolbar
      id="toolbarId_fs2"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button
          v-if="getLimit('profitFeeMonth_search_button')"
          @click="funcFilter"
          >查询</el-button
        >
        <!-- <el-button @click="funcAdd">新增</el-button> -->
        <el-date-picker
          v-model="listQuery.gmtCreatedRange"
          type="daterange"
          value-format="yyyy-MM-dd"
          :picker-options="optionsPicker"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="value => changeDate(value, 'gmtCreated')"
        />
        <el-button
          v-if="getLimit('profitFeeMonth_export_button')"
          @click="funcExport"
          >导出</el-button
        >
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      resizable
      border
      :loading="loading"
      highlight-current-row
      highlight-hover-row
      row-id="id"
      class="mytable-footer"
      height="80%"
      :data="tableData"
      show-footer
      :footer-method="footerMethod"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column
          field="branchCode"
          title="承运主体"
          :formatter="formatterBranch"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.branchCode"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in branchList"
              :key="item.code"
              :label="item.groupName"
              :value="item.code"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="shipmentName"
          title="托运人名称"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.shipmentName"
            placeholder="请输入托运人名称"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="shipmentPhone"
          title="托运人电话"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.shipmentPhone"
            placeholder="请输入托运人电话"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="upstreamName"
          title="上游客户"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.upstreamName"
            placeholder="请输入上游客户名称"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="createdYear"
          title="归属年份"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.createdYear"
            clearable
            type="year"
            value-format="yyyy"
            placeholder="请输入归属年份"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="createdMonth"
          title="归属月份"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.createdMonth"
            placeholder="请输入归属月份"
            clearable
            @keyup.native="
              e =>
                (e.target.value =
                  e.target.value > 12 ? 12 : e.target.value.replace(/\D/g, ''))
            "
          />
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="createYearMonth"
        title="归属年月"
        min-width="100"
        sortable
      />
      <vxe-table-column
        field="deliveryFeePracticalSum"
        title="实际承运人合计收款"
        min-width="100"
        sortable
      />
      <!-- <vxe-table-column
        field="shipperDeliveryFeeSum"
        title="托运人合计付款"
        min-width="100"
        sortable
      /> -->
      <vxe-table-column
        field="profitFee"
        title="利润"
        min-width="100"
        sortable
      />
      <vxe-table-column field="profitFeeFate" title="利润率" min-width="100" />
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-sizes="Pagingconf"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <downloadData ref="downloadRef" />
  </div>
</template>

<script>
import request from "@/utils/request";

export default {
  name: "Index",
  data() {
    return {
      tableData: [],
      exportObj: {
        exportUrl: "/ntocc-tms-api/statistics/exportProfitFeeMonth", //导出接口
        name: "月度利润"
      },
      listQuery: {
        upstreamName: "", // 上游客户名称
        shipmentName: "", // 托运人名称
        shipmentPhone: "", // 托运人电话
        upstreamPhone: "", // 上游客户电话
        createdMonth: "", // 归属月份
        createdYear: "", // 归属年份
        createYearMonth: "", //归属年月
        inFeeSum: "", //上游客户费用
        gmtCreatedStart: "", // 统计时间开始
        gmtCreatedEnd: "", // 统计时间结束
        shipperDeliveryFeeSum: "", //托运人实际运费
        deliveryFeePracticalSum: "", //实际运费
        profitFee: "", //利润
        profitFeeFate: "", //利润率
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0
      },
      // 机构列表
      branchList: this.$store.state.components.branchList
    };
  },
  created() {
    this.findList();
  },
  methods: {
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        request({
          url: "ntocc-tms-api/statistics/profitFeeMonth",
          method: "get",
          params: this.listQuery
        }).then(response => {
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;
          this.loading = false;
          resolve();
        });
      });
    },
    // 翻译机构
    formatterBranch({ cellValue }) {
      const item = this.branchList.find(item => item.code === cellValue);
      return item ? item.groupName : "";
    },
    // 分页handle
    handlePageChange({ currentPage, pageSize }) {
      this.listQuery.pageNum = currentPage;
      this.listQuery.pageSize = pageSize;
      this.findList();
    },
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "合计";
          }
          if (
            [
              "deliveryFeePracticalSum",
              "shipperDeliveryFeeSum",
              "profitFee"
            ].includes(column.property)
          ) {
            return this.$XEUtils.sum(data, column.property);
          }
          return "-";
        })
      ];
    }
  }
};
</script>

<style scoped></style>
